import '../css/Sidebar.css';

import FolderIcon from '@mui/icons-material/Folder';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem, treeItemClasses  } from '@mui/x-tree-view/TreeItem';
import Avatar from '@mui/material/Avatar';
import { alpha, styled } from '@mui/material/styles';
import WhiteboardIcon from '@mui/icons-material/BorderColor';
import Tooltip from '@mui/material/Tooltip';
import { isMobile } from 'react-device-detect';
import Collapse from '@mui/material/Collapse';
import { LinearProgress } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Settings from './Settings';
import DialogTitle from '@mui/material/DialogTitle';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useSpring, animated } from '@react-spring/web';
import IconButton from '@mui/material/IconButton';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import NoteIcon from '@mui/icons-material/Note';
import {useState, forwardRef, useEffect, memo} from 'react'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear } from '@fortawesome/free-solid-svg-icons'
import {useNavigate} from 'react-router-dom'
import { BuildTree, buildTree } from './BuildTree';
function TransitionComponent(props) {
    const style = useSpring({
      to: {
        opacity: props.in ? 1 : 0,
        transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
      },
    });
  
    return (
      <animated.div style={style}>
        <Collapse {...props} />
      </animated.div>
    );
  }
const CustomTreeItem = forwardRef((props, ref) => (
    <TreeItem {...props} TransitionComponent={TransitionComponent} ref={ref} />
  ));
  
  const StyledTreeItem = styled(CustomTreeItem)(({ theme }) => ({
    [`& .${treeItemClasses.iconContainer}`]: {
      '& .close': {
        opacity: 0.3,
      },
    },
    [`& .${treeItemClasses.group}`]: {
      marginLeft: 15,
      paddingLeft: 18,
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
  }));
  
export default function LeftSideBar({
    lowPower,
    setLowPower,
    username,
    encrypt,
    addr,
    loggedIn,
    colorTheme,
    setColorTheme,
    setAllFiles,
    colorScheme,
    setStorageUsage,
    clientId,
    sessionId,
    storageUsage,
    setColorScheme,
    theme,
    mainVersion,
    allFiles,
    setContentLoader,
}) {
    const navigate = useNavigate()
    const [globalFolders, setGlobalFolders] = useState([])
    const [selectedFolder, setSelectedFolder] = useState(0);
    const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
    const [searchTerm, setSearchTerm] = useState('');
    const [selected, setSelected] = useState([]);
    const [showTree, setShowTree] = useState(true);
    const [leftSideBar, setLeftSideBar] = useState(true)
    const [itemId, setItemId] = useState(null)
    const [itemName, setItemName] = useState(null)
    const [itemType, setItemType] = useState(null)
    const [expandedNodes, setExpandedNodes] = useState([]);
    const [folderRename, setFolderRename] = useState(null)
    const [moveId, setMoveId] = useState(null);
    const [shareName, setShareName] = useState(null)
    const [folderToRename, setFolderToRename] = useState(null)
    const [folderToRenameId, setFolderToRenameId] = useState(null)
    const [createActive, setCreateActive] = useState(false)
    const [prettyStorage, setPrettyStorage] = useState('0B')
    const [storageDecimal, setStorageDecimal] = useState(0)
    const [settingsOpen, setSettingsOpen] = useState(false)
    const [tempFiles, setTempFiles] = useState([])
    function formatBytes(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
    useEffect(()=>{
      let timer
      if(allFiles.length < tempFiles.length) {
        setShowTree(false)
        timer = setTimeout(()=>{
          setShowTree(true)
        }, 50)
      }
      setTempFiles(allFiles)
      return () => {
        try {
          
        clearTimeout(timer)
        }catch(e) {
          console.error(e)
        }
      }
    }, [allFiles])
    useEffect(()=>{
      let decimal = (storageUsage / 1073741824) * 100
      if(decimal > 100) {
        decimal = 100
      }
      setStorageDecimal(decimal)
      setPrettyStorage(formatBytes(storageUsage))
    }, [storageUsage, allFiles])
    useEffect(() =>{
      const folders = allFiles.filter(file => file.type === 'folder')
      setGlobalFolders(folders)
    },   [allFiles])
    useEffect(() => {
      const handleResize = () => {
        const newViewportWidth = window.innerWidth;
    
        // Update state only if the new width is significantly different
        if (Math.abs(newViewportWidth - viewportWidth) > 10) {
          setViewportWidth(newViewportWidth);
        }
      };
    
      // Set initial viewport height
      setViewportWidth(window.innerWidth);
    
      // Attach event listener for window resize
      window.addEventListener('resize', handleResize);
    
      // Cleanup the event listener on component unmount
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [viewportWidth]); // Add viewportWidth as a dependency to useEffect
    

    const [allItems, setAllItems] = useState(allFiles)
    useEffect(()=>{
      setAllItems(allFiles)
    }, [allFiles])
    const [anchorEl, setAnchorEl] = useState(null);
    
    const [openRenameFolder, setOpenRenameFolder] = useState(false);
    const [openDeleteFolder, setOpenDeleteFolder] = useState(false);
    const [openMoveFolder, setOpenMoveFolder] = useState(false);
    const [openShareFile, setOpenShareFile] = useState(false);
    const handleClickOpenRenameFolder = () => {
      setOpenRenameFolder(true);
    };

    const handleCloseRenameFolder = () => {
      setOpenRenameFolder(false);
    };
    const handleClickOpenDeleteFolder = () => {
      setOpenDeleteFolder(true);
    };

    const handleCloseDeleteFolder = () => {
      setOpenDeleteFolder(false);
    };
    
    const handleClickOpenMoveFolder = () => {
      setMoveId(null)
      setOpenMoveFolder(true);
    };

    const handleCloseMoveFolder = () => {
      setOpenMoveFolder(false);
    };
    const handleClickOpenShareFolder = () => {
      setOpenShareFile(true);
    };

    const handlecloseShareFile = () => {
      setOpenShareFile(false);
    };
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    function prepFile(id, name, type) {
      setItemId(id)
      setItemName(name)
      setItemType(type)
    }
    const handleSelect = (event, nodeIds) => {
        setSelected(nodeIds);
      };
      function rename() {
        setFolderRename(itemName)
        handleClickOpenRenameFolder()
      }
      function share() {

        handleClickOpenShareFolder()
      }
      function handleRename() {
        //todo Rename function
        setOpenRenameFolder(false)
      }
      function handleMove() {

        
        const message = {
          type: `move-${itemType}`,
          clientId,
          id: itemId,
          parent: moveId,
        }
        //todo sendMessage(JSON.stringify(message))
        setOpenMoveFolder(false)
      }
      function handleDelete() {
        //todo Delete function
        setOpenDeleteFolder(false)
      }
      const buildSearchTree = (items) => (
        items.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()) && item.type !== 'folder')

        .map(item => (
            <TreeItem
              sx={{borderRadius: 5, width: '100%'}}
              key={`${item.type}${item.id}`}
              nodeId={String(item.id)}
              label={<>
              <Box sx={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}
              >
                <span style={{display: 'flex', alignItems: 'center', gap: 5}}>
                    <span style={{fontSize: 'smaller'}}>
                        {getIcon(item.type)}
                    </span>
                    <span style={{display: 'flex', flexDirection: 'column', margin: 5,}}>
                      <span>
                        
                    {item.name}
                      </span>
                      
                    <span style={{fontSize: 'smaller', fontWeight: 'bold', textTransform: 'capitalize'}}>
                      {item.type}
                    </span> 
                    </span>
                </span>
              </Box>
              </>}
              onClick={(e) => {
                if (item.type === 'folder') {
                  e.stopPropagation()
                  setSearchTerm('')
                  expandFolderRecursively(item.id, items)
                }else {
                    e.stopPropagation()
                    handleFolderClick(item.parent)
                    if(item.type === 'note') {
                      if(viewportWidth <= 650) {
                        setLeftSideBar(false)
                      }
                          
                        navigate(`editor/${item.id}`)
                    }else {
                        if(viewportWidth <= 650) {
                          setLeftSideBar(false)
                        }
                        navigate(`whiteboard/${item.id}`)
                    }
                }
              }}
            >
            </TreeItem>
          ))
      );
      
      
      
      const expandFolderRecursively = (folderId, items) => {
          expandFolder(folderId);
      };

    const handleFolderClick = (id) => {
        setSelectedFolder(id)
        console.log(id)
        expandFolder(id);
      };
    
  const expandFolder = (folderId) => {
    const expandedSet = new Set(expandedNodes);
    const item = allItems.find(item => item.id === folderId);
    if (item) {
      // Expand the clicked folder and all its parent folders
      let parentId = item.parent;
      while (parentId !== 0) {
        expandedSet.add(String(parentId));
        parentId = allItems.find(item => item.id === parentId)?.parent || 0;
      }
      expandedSet.add(String(folderId));
      setExpandedNodes(Array.from(expandedSet));
    }
  };
      const getIcon = (type) => {
        switch (type) {
          case 'folder':
            return <FolderIcon />;
          case 'note':
            return <NoteIcon />;
          case 'board':
            return <EditIcon />;
          default:
            return null;
        }
      };
      
  const handleItemSelected = (item) => {
    // Handle item selection logic here
    console.log('Selected Item:', item);
  };

    function createFolder() {
        setSearchTerm('')
        const message = {
            type: 'create-folder',
            parent: selectedFolder,
            sessionId,
            clientId,

        }
        //todo sendMessage(JSON.stringify(message))
        expandFolder(selectedFolder)
        setCreateActive(false)
    }
            function handleShare() {

            }
    //Move
    const buildMoveTree = (items, parent = 0) => (
      items
        .filter(item => (item.parent === parent && item.id != itemId))
        .map(item => (
          <TreeItem
            sx={{borderRadius: 5}}
            key={`${item.type}${item.id}`}
            nodeId={String(item.id)}
            label={<>
            <Box sx={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}
            >
              <span style={{display: 'flex', alignItems: 'center', gap: 5}}>
                  <span style={{fontSize: 'smaller'}}>
                      {getIcon(item.type)}
                  </span>
                  {item.name}
              </span>
            </Box>
            </>}
            onClick={(e) => {
              if (item.type === 'folder') {
                e.stopPropagation()
                setMoveId(item.id);
              }
            }}
          >
            {buildMoveTree(items, item.id)}
          </TreeItem>
        ))
    );
    function createNote() {
        setSearchTerm('')
        const message = {
            type: 'create-note',
            parent: selectedFolder,
            sessionId,
            clientId,

        }
        //todo sendMessage(JSON.stringify(message))
        expandFolder(selectedFolder)
        setCreateActive(false)
    }
    function createBoard() {
        setSearchTerm('')
        const message = {
            type: 'create-board',
            parent: selectedFolder,
            sessionId,
            clientId,

        }
        //todo sendMessage(JSON.stringify(message))
        expandFolder(selectedFolder)
        setCreateActive(false)
    }


    var firstCharacter = ''
    if(loggedIn) {
        firstCharacter = username.charAt(0);
    }

    const handleEnterKey = (event) => {
      if (event.key === 'Enter') {
        event.stopPropagation()
        event.preventDefault()
        // Handle the Enter key press here
        handleRename()
        // You can add your logic here, for example, call a function or perform an action
      }
    };
    
    const handleEnterKeyShare = (event) => {
      if (event.key === 'Enter') {
        event.stopPropagation()
        event.preventDefault()
        // Handle the Enter key press here
        handleShare()
        // You can add your logic here, for example, call a function or perform an action
      }
    };
    const settings = () => {
      setSettingsOpen(true)
    }
    const [sideBarWidth, setSidebarWidth] = useState(300)
    const [oldClientX, setOldClientX] = useState(0)
    const [resizeMode, setResizeMode] = useState('false')
    const [safeWidth, setSafeWidth] = useState(300)
    function resizeLeft(e) {
      const clientX = e.clientX
      const diff = clientX - oldClientX
      if(((sideBarWidth + diff) > 250) && ((sideBarWidth + diff) < 1280)) {
      setSidebarWidth(sideBarWidth + diff)
      setOldClientX(clientX)
      }
    }
    const handleCheckboxChange = () => {
      // setLeftSideBar(!leftSideBar);
     };
    return(
      <>
      
      <span onClick={()=>{
            setLeftSideBar(!leftSideBar)
          }}
          style={{
            position: 'fixed',
            left: 8,
            top: 10,
            zIndex: 3001
          }}
          ><input type="checkbox" checked={leftSideBar} onChange={handleCheckboxChange} id="checkbox1" className="checkbox1 visuallyHidden" />
                
          <svg
              className={`ham hamRotate ham8 ${leftSideBar ? 'active' : ''}`}
              viewBox="0 0 100 100"
              width="55"
              onClick={handleCheckboxChange}  
          >
              <path
                      className="line top"
                      stroke="white"
                      d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20" />
              <path
                      className="line middle"
                      stroke="white"
                      d="m 30,50 h 40" />
              <path
                      className="line bottom"
                      stroke="white"
                      d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20" />
          </svg></span>

      {leftSideBar &&
      <div className={leftSideBar ? (resizeMode === 'true' ? 'left-resize show-resize': 'left-resize'): 'left-resize left-resize-close'}
      style={{
        left: sideBarWidth
      }}
      onMouseDown={(e)=>{
        setResizeMode('true');
        setOldClientX(e.clientX);
      }}
      
      ></div>
      }

      {resizeMode === 'true' && <div className='resizeme' onMouseMove={resizeLeft} onMouseUp={()=>{setResizeMode('false'); setSafeWidth(sideBarWidth)}}>
        
        </div>}

      <div className={leftSideBar ? (resizeMode === 'true' ? 'left-sidebar-placeholder cancel-transition': 'left-sidebar-placeholder'): 'left-sidebar-placeholder close-sidebar-placeholder'}
        style={{
          width: sideBarWidth,
          minWidth: sideBarWidth
        }}
      ></div>
          
        <div className={leftSideBar ? 'left-sidebar': 'left-sidebar left-sidebar-close'}
        
        style={{
          width: sideBarWidth
        }}>
            <div className="sidebar-head">
                <div className="user-container">
                    <div className="user-picture">
                        <Avatar  sx={{ width: '100%', height: '100%', backgroundColor: 'transparent', color: 'white' }}>
                            {firstCharacter}
                        </Avatar>
                    </div>
                    <div className="user-name">
                        Hi {username}
                    </div>
                    <span  className="pointer">
                      <Tooltip title="Open Settings" placement='right' arrow>
                        
                      <IconButton aria-label="settings" style={{fontSize: 'large'}} onClick={settings}>
                            <FontAwesomeIcon icon={faGear} />
                        </IconButton>
                      </Tooltip>
                    </span>
                </div>
            </div>
            <div style={{width: '100%', display: 'flex',overflowY: 'hidden',flex: 1, flexDirection: 'column', alignItems: 'center',}}>
                <Box sx={{ display: 'flex', alignItems: 'flex-end' ,gap: 1, marginBottom: 3, }}>
                    <SearchIcon />
                    <TextField id="input-with-sx" label="Search stuff..." variant="standard"  
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}/>
                                </Box>
                                <div style={{flex: 1, overflowY: 'auto', width: '100%', display: 'flex', flexDirection: 'column'}} >

                                    {searchTerm.trim() === "" ?
                                    <>
                                <TreeView
                                defaultCollapseIcon={<span>-</span>}
                                defaultExpandIcon={<span>+</span>}
                                selected={selected}
                                onNodeSelect={handleSelect}
                            >
                              <div style={{
                                width: '100%',
                                position: 'absolute',
                                left: -20,
                                height: 'calc(100dvh - 300px)',
                                overflowY: 'auto'
                              }}>
                                {1 === 1 && <BuildTree addr={addr} setStorageUsage={setStorageUsage} nextList={true} mainVersion={mainVersion} setAllFiles={setAllFiles} allItems={allItems} parent='shared' clientId={clientId} sessionId={sessionId}/>}
                                {1 === 1 && <BuildTree addr={addr} setStorageUsage={setStorageUsage} nextList={true} mainVersion={mainVersion} setAllFiles={setAllFiles} allItems={allItems} parent='homeroot' clientId={clientId} sessionId={sessionId}/>}
                              </div>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                        'aria-labelledby': 'basic-button',
                        
                        }}
                    >
                      <Tooltip title={`Rename ${itemName}`} arrow placement='right'>
                      <MenuItem sx={{display: 'flex', gap: 1.5, alignItems: 'center'}} onClick={()=>{handleClose(); rename();}} ><DriveFileRenameOutlineIcon /> Rename</MenuItem>
                        
                      </Tooltip>
                      
                      <Tooltip title={`Move ${itemName}`} arrow placement='right'>
                        <MenuItem sx={{display: 'flex', gap: 1.5, alignItems: 'center'}} onClick={()=>{handleClose(); handleClickOpenMoveFolder();}}><DriveFileMoveIcon /> Move</MenuItem>
                        </Tooltip>
                        
                      <Tooltip title={`Delete ${itemName}`} arrow placement='right'>
                        <MenuItem sx={{display: 'flex', gap: 1.5, alignItems: 'center'}} onClick={()=> {handleClose(); handleClickOpenDeleteFolder()}}><DeleteIcon /> Delete</MenuItem>
                        </Tooltip>
                    </Menu>
                    </TreeView>
       
            
            <div style={{flex: 1}} onClick={() => {setSelectedFolder('root'); setSelected([])}}></div>
            </>
            :
            
                
      <div style={{ display: 'flex', flexDirection: 'column' , width: '100%', alignItems: 'center'}}>
         <TreeView
      defaultCollapseIcon={<span>-</span>}
      defaultExpandIcon={<span>+</span>}
      selected={selected}
      onNodeSelect={handleSelect}
  >
      {buildSearchTree(allItems, searchTerm)}
      </TreeView>
    </div>    
                
                }
                </div>
                <div style={{
                  width: '80%',
                  fontSize: 'smaller',
                  textAlign: 'center'
                }}>
                  
      <LinearProgress variant="determinate" value={storageDecimal} />
      {prettyStorage} used of 1.00GB
                </div>
            </div>
             {/**Rename folder */}
        <Dialog
        open={openRenameFolder}
        onClose={handleCloseRenameFolder}
        sx={{
          minWidth: 300
        }}
      >

        <DialogContent sx={{minWidth: 300}}>
          <DialogContentText>
            <h2>Rename {itemName}</h2>
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            value={folderRename}
            onChange={(e) =>{ setFolderRename(e.target.value)}}
            name="folder"
            label="Rename"
            type="text"
            fullWidth
            onSubmit={()=>{alert('hi')}}
            variant="standard"
            onKeyDown={handleEnterKey}

          />
        </DialogContent>
        <DialogActions>
          <md-outlined-button onClick={handleCloseRenameFolder}>
            Cancel
          </md-outlined-button>
          <md-filled-button onClick={handleRename}>
            Rename
          </md-filled-button>
        </DialogActions>
      </Dialog>
      {/**End rename folder */}
       {/**delete folder */}
       <Dialog
        open={openDeleteFolder}
        onClose={handleCloseDeleteFolder}
        sx={{
          minWidth: 300
        }}
      >

        <DialogContent sx={{minWidth: 300}}>
          <DialogContentText>
            <h2>Delete {itemName}</h2>
          </DialogContentText>
          Are you sure you want to delete this file?
        </DialogContent>
        <DialogActions>
          <md-outlined-button onClick={handleCloseDeleteFolder}>
            Cancel
          </md-outlined-button>
          <md-filled-button onClick={handleDelete}>
            Yes, Delete
          </md-filled-button>
        </DialogActions>
      </Dialog>
      {/**End delete folder */}

 {/**move folder */}
 <Dialog
        open={openMoveFolder}
        onClose={handleCloseMoveFolder}
        sx={{
          minWidth: 300
        }}
      >

        <DialogContent sx={{minWidth: 300}}>
          <DialogContentText>
            <h2>Move {itemName}</h2>
          </DialogContentText>
          <TreeView
                                defaultCollapseIcon={<span>-</span>}
                                defaultExpandIcon={<span>+</span>}
                            >
                              
      {globalFolders.length === 0 && <>No folders</>}
      <TreeItem
            sx={{borderRadius: 5}}
            key={`folder-root`}
            nodeId={'root'}
            label={<>
            <Box sx={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}
            >
              <span style={{display: 'flex', alignItems: 'center', gap: 5}}>
                  <span style={{fontSize: 'smaller'}}>
                      {getIcon('folder')}
                  </span>
                  {username}
              </span>
            </Box>
            </>}
            onClick={(e) => {
                e.stopPropagation()
                setMoveId('root');
              
            }}
          >
          {buildMoveTree(globalFolders)}
          </TreeItem>
                                </TreeView>
        </DialogContent>
        <DialogActions>
          <md-outlined-button onClick={handleCloseMoveFolder}>
            Cancel
          </md-outlined-button>
          {moveId === null ?
          
          <md-filled-button  disabled>
            Move
          </md-filled-button>
          :
          
          <md-filled-button  onClick={handleMove}>
            Move
          </md-filled-button>}
        </DialogActions>
      </Dialog>
      {/**End move file */}

      {/**Share file */}
      <Dialog
        open={openShareFile}
        onClose={handlecloseShareFile}
        sx={{
          minWidth: 300
        }}
      >

        <DialogContent sx={{minWidth: 300}}>
          Feature not yet implemented

        </DialogContent>
        <DialogActions>
          <md-filled-button onClick={handlecloseShareFile}>
            Ok
          </md-filled-button>
        </DialogActions>
      </Dialog>
      {/**End share file */}
        </div>
        <Settings setLowPower={setLowPower} mainVersion={mainVersion} lowPower={lowPower} username={username} colorTheme={colorTheme} setColorTheme={setColorTheme}  open={settingsOpen} setOpen={setSettingsOpen} theme={theme} setColorScheme={setColorScheme} colorScheme={colorScheme} />

        </>
    )
}